import { useEffect } from 'react';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('networkbarscroll');
function getSelectedNode(scrollable, selectedItemClassName) {
    if (!scrollable) {
        return null;
    }
    // find the selected node
    var selectedNode = scrollable === null || scrollable === void 0 ? void 0 : scrollable.querySelector(".".concat(selectedItemClassName));
    // but return its ancestor that is used to offset within the scrollable
    while (selectedNode) {
        if (selectedNode.offsetParent === scrollable) {
            return selectedNode;
        }
        selectedNode = selectedNode.offsetParent;
    }
    return null;
}
export function useScrollDescendantIntoView(scrollableRef, selectedItemClassName, isInitialized) {
    useEffect(function () {
        if (!isInitialized) {
            return;
        }
        var scrollable = scrollableRef.current;
        var selectedNode = getSelectedNode(scrollable, selectedItemClassName);
        if (!selectedNode || !scrollable) {
            return;
        }
        // do nothing if our element is visible
        if (selectedNode.offsetTop + selectedNode.offsetHeight <
            scrollable.scrollTop + scrollable.offsetHeight) {
            logger.log('Not scrolling, visible', scrollable);
            return;
        }
        // position to center
        scrollable.scrollTop =
            scrollable.scrollTop +
                selectedNode.offsetTop -
                (scrollable.offsetHeight - selectedNode.offsetHeight) / 2;
        logger.log('Scrolled to', scrollable, scrollable.scrollTop);
    }, [selectedItemClassName, isInitialized, scrollableRef]);
    return scrollableRef;
}
//# sourceMappingURL=useScrollDescendantIntoView.js.map